import {
  GraphQLErrorExtensions,
  GraphQLFormattedErrorExtensions
} from 'graphql'

export const persianRegex = /[\u0600-\u06FF۰۱۲۳۴۵۶۷۸۹٠١٢٣٤٥٦٧٨٩‌ـ]/

// export const persianLetterRegex = /^[\u0600-\u06FF\s]*$/
export const persianLetterRegex = /^[\u0600-\u06FF0-9\s\W_]*$/

export const entityNameRegex = /^[^\<\>\+\/\\\\&\^\%$\#\@\!\?\'\"\;\:\]\[]$/

export const entityCodeRegex = /^[a-zA-Z0-9\-\_]*$/

// Regular expression to validate the HH:MM time format
export const timeRegex = /^([01]\d|2[0-3]):([0-5]\d)$/

export const numbersOnlyRegex = /^[0-9]*$/ // Allows only digits (0-9)

export const tenNumbersOnlyRegex = /^\d{0,10}$/

export const elevenNumbersOnlyRegex = /^\d{0,11}$/

export const iranMobileRegex = /^(?:\+98|0)\d{10}$/

export function extractError(
  extensions?: GraphQLErrorExtensions[] | GraphQLFormattedErrorExtensions
): string {
  if (extensions && !Array.isArray(extensions)) {
    return (extensions as Record<string, any>).error ?? ''
  }

  return ''
}

export const errorNoCartFound =
  'rpc error: code = Unknown desc = cart not found'

export const ErrorPreparePayment =
  'the requested amount is not equal to recovery amount'

export const emailRegex =
  /^[a-zA-Z0-9.!#$%&'+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)$/
export const englishRegex = /^[A-Za-z\s]*$/
export const allowedEmailRegex = /^[A-Za-z0-9._@-]*$/
export const strictEmailFormatRegex =
  /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/
